import React from 'react';
import RequritmentLibrary from '../components/Library';
import { withLmsStore } from '../utils/lmsStore';

const LMSRecruitmentLibraryContainer = (props) => {
  return <RequritmentLibrary {...props} />;
};

export default withLmsStore(LMSRecruitmentLibraryContainer);
